// extracted by mini-css-extract-plugin
export default {"embedContainer":"MeetingEmbed_embedContainer__iiECs","meetingFrame":"MeetingEmbed_meetingFrame__7bIpu"};